/******/ (() => { // webpackBootstrap
    var __webpack_exports__ = {};
    Shopify.theme.jsProductTabs = {
        init: function ($section) {
            Shopify.theme.jsProductTabs = $.extend(this, Shopify.theme.getSectionData($section));
            this.$section = $section
            this.$buttons = $section.find('[data-buttons]')
            this.$tabs = $section.find('[data-tabs]')

            this.renderTabs()
            this.handleEvents()
        },
        handleEvents() {
            this.$buttons.find('[data-tab]').on('click', function (e) {
                let name = $(e.target).data('tab')
                this.open(name)
            }.bind(this))
        },
        open(name) {
            this.$buttons.find('[data-tab]').removeClass('is-active')
            this.$tabs.find('[data-tab]').removeClass('is-active')
            this.$buttons.find(`[data-tab="${name}"]`).addClass('is-active')
            this.$tabs.find(`[data-tab="${name}"]`).addClass('is-active')
        },
        renderTabs() {
            this.$tabs.find('[data-tab]').each(function (index, item) {
                let name = $(item).data('tab')
                let tab = $(document).find(`[data-tab-identifier="${name}"]`)
                $(document).find(`[data-tab-identifier="${name}"]`).remove()
                $(item).html(tab)
                let hasUnWrap = $(item).find('[data-unwrap-on-mobile]')
                if(!isScreenSizeLarge() && hasUnWrap.length){
                    hasUnWrap.unwrap()
                }
            }.bind(this))
        },
        blockSelect: function ($section, blockId) {
            let name = this.$buttons.find(`[data-block-id="${blockId}"]`).data('tab')
            this.open(name)
        },
        unload: function ($section) {
            this.$buttons.find('[data-tab]').off('click')
        }
    }

    /******/
})()
    ;